<template>
  <div class="modal-overlay" @click.self="$emit('close')">
    <div
      class="premium-modal"
      :class="[`modal-${size}`]"
      :style="width ? { width: width } : {}"
    >
      <!-- HEADER -->
      <div v-if="$slots.header || title" class="modal-header">
        <div v-if="icon" class="modal-brand-icon" :class="iconVariant">
          <i :class="icon"></i>
        </div>
        <div class="modal-titles">
          <h3 v-if="title" class="modal-title">{{ title }}</h3>
          <p v-if="subtitle" class="modal-subtitle">{{ subtitle }}</p>
          <slot name="header"></slot>
        </div>
      </div>

      <!-- BODY -->
      <div
        v-if="$slots.default"
        class="modal-body"
        :class="{ 'body-sm': size === 'sm' }"
      >
        <slot></slot>
      </div>

      <!-- FOOTER -->
      <div
        v-if="$slots.footer"
        class="modal-footer"
        :class="{ 'footer-sm': size === 'sm' }"
      >
        <slot name="footer"></slot>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ModalBase",
  props: {
    title: {
      type: String,
      default: "",
    },
    subtitle: {
      type: String,
      default: "",
    },
    width: {
      type: String,
      default: "",
    },
    size: {
      type: String,
      default: "md", // sm, md, lg
      validator: (value) => ["sm", "md", "lg"].includes(value),
    },
    icon: {
      type: String,
      default: "",
    },
    iconVariant: {
      type: String,
      default: "amber", // success, amber, warning, error
    },
  },
  emits: ["close"],
};
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(2px);
  z-index: 9998;
  display: flex;
  align-items: center;
  justify-content: center;
}

.premium-modal {
  background: rgba(255, 255, 255, 0.98);
  backdrop-filter: blur(20px);
  -webkit-backdrop-filter: blur(20px);
  border: 1px solid rgba(255, 255, 255, 0.3);
  box-shadow: var(--shadow-premium);
  border-radius: var(--border-radius-xl);
  overflow: hidden;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  max-width: 95vw;
  max-height: 90vh;
}

.modal-sm {
  width: 440px;
}
.modal-md {
  width: 650px;
}
.modal-lg {
  width: 850px;
}

.modal-header {
  padding: 20px 32px 16px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  gap: 25px;
  border-bottom: 1px solid var(--gray-100);
  text-align: left;
  flex-shrink: 0;
}

.modal-brand-icon {
  width: 44px;
  height: 44px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 22px;
  flex-shrink: 0;
}

.modal-brand-icon.success {
  background: var(--success-bg);
  color: var(--success-text);
}

.modal-brand-icon.amber {
  background: var(--warning-bg);
  color: var(--amber-300);
}

.modal-brand-icon.warning {
  background: #fef9c3;
  color: var(--warning-deep);
}

.modal-brand-icon.error {
  background: #fee2e2;
  color: var(--error-text);
}

.modal-titles {
  display: flex;
  flex-direction: column;
  gap: 0px;
}

.modal-title {
  font-family: var(--font-family-header);
  font-size: 18px;
  color: var(--gray-900);
  margin: 0;
  line-height: 1.2;
}

.modal-subtitle {
  font-size: 13px;
  color: var(--gray-500);
  margin: 0;
}

.modal-body {
  padding: 24px 32px;
  overflow-y: auto;
}

.body-sm {
  padding: 12px 32px;
}

.modal-footer {
  padding: 16px 32px 20px;
  background: var(--gray-50);
  display: flex;
  justify-content: flex-end;
  gap: 12px;
  border-top: 1px solid var(--gray-100);
  flex-shrink: 0;
}

.footer-sm {
  padding: 12px 32px;
}
</style>
